"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _SubtractCircle = require("grommet-icons/es6/icons/SubtractCircle");

var _AddCircle = require("grommet-icons/es6/icons/AddCircle");

var baseSpacing = 24;
var scale = 6;
var baseFontSize = baseSpacing * 0.584; // 14

var fontScale = baseSpacing / scale; // 4
// colours
// https://wisdomtree.frontify.com/d/jlGr1mRdpvLo/digital#/color-palette/colors

var colors = {
  white: '#fff',
  black: '#333',
  wtGrey: '#5B6770',
  teal: '#05a9b1',
  blue: '#0047BB',
  // graysclae
  lightGray: '#F4F4F5',
  silver: '#BDC2C6',
  grey: '#8C959B',
  // secondary colors
  green: '#65BD18',
  sky: '#00A9E0',
  auburn: '#84344E',
  orange: '#F68D2E'
};
var colorDefault = colors.wtGrey;
var colorPrimary = colors.teal;
var colorSecondary = colors.blue;
var global = {
  font: {
    size: "".concat(baseFontSize, "px")
  },
  colors: {
    control: '#2DCCD3'
  },
  control: {
    border: {
      width: '1px',
      radius: '0px',
      color: colorDefault
    },
    disabled: {
      opacity: 0.4
    },
    selected: colorPrimary
  },
  focus: {
    border: {
      color: colorPrimary
    }
  },
  input: {
    padding: "".concat(baseSpacing / 2, "px") // weight: 600,

  },
  edgeSize: {
    none: '0px',
    hair: '1px',
    // for Chart
    xxsmall: "".concat(baseSpacing / 8, "px"),
    // 3
    xsmall: "".concat(baseSpacing / 4, "px"),
    // 6
    small: "".concat(baseSpacing / 2, "px"),
    // 12
    medium: "".concat(baseSpacing, "px"),
    // 24
    large: "".concat(baseSpacing * 2, "px"),
    // 48
    xlarge: "".concat(baseSpacing * 4, "px") // 96

  },
  opacity: {
    strong: 0.8,
    medium: 0.5,
    weak: 0.1
  },
  selected: {
    background: colorPrimary
  }
}; // text

var text = {
  xsmall: {
    size: "".concat(baseFontSize - 2 * fontScale, "px"),
    height: 1.5
  },
  small: {
    size: "".concat(baseFontSize - fontScale, "px"),
    height: 1.43
  },
  medium: {
    size: "".concat(baseFontSize, "px"),
    height: 1.375
  },
  large: {
    size: "".concat(baseFontSize + fontScale, "px"),
    height: 1.167
  },
  xlarge: {
    size: "".concat(baseFontSize + 2 * fontScale, "px"),
    height: 1.1875
  },
  xxlarge: {
    size: "".concat(baseFontSize + 4 * fontScale, "px"),
    height: 1.125
  }
}; // headins

var heading = {
  1: {
    weight: '700',
    size: '34px',
    media: {
      min768: {
        size: '34px'
      }
    }
  },
  2: {
    weight: '300',
    size: '22px',
    media: {
      min768: {
        size: '28px'
      }
    }
  },
  3: {
    weight: '300',
    size: '18px',
    media: {
      min768: {
        size: '18px'
      }
    }
  },
  4: {
    weight: '600',
    size: '14px',
    media: {
      min768: {
        size: '14px'
      }
    }
  }
};
var drop = {
  backgroundColor: '#ffffff',
  border: {
    radius: '0px',
    width: '1px',
    color: colorDefault
  },
  shadowSize: 'small',
  zIndex: '20'
};
var suggestion = {
  hover: {
    color: colors.white,
    backgroundColor: colorPrimary
  },
  padding: '12px'
}; // suggestions.hover.backgroundColor
// buttons

var button = {
  /* border: {
    width: '0px',
  }, */
  fontWeight: '700',
  padding: {
    vertical: '10px',
    horizontal: '19px'
  },
  backgroundColor: colorDefault,
  color: '#fff',
  primary: {
    backgroundColor: colorPrimary
  },
  secondary: {
    backgroundColor: colorSecondary
  }
}; // box

var box = {
  "default": {
    backgroundColor: colorDefault,
    color: '#fff'
  },
  primary: {
    backgroundColor: colorPrimary,
    color: '#fff'
  },
  secondary: {
    backgroundColor: colorSecondary,
    color: '#fff'
  }
};
var anchor = {
  textDecoration: 'none',
  hover: {
    textDecoration: 'underline'
  }
};
var checkBox = {
  border: {
    color: colorDefault,
    width: '2px'
  },
  check: {
    border: {
      color: colorPrimary
    },
    radius: '0px',
    thickness: '4px'
  },
  color: colorPrimary,
  // extend: undefined,
  // gap: undefined
  hover: {
    border: {
      color: colorPrimary
    }
  },
  size: "".concat(baseSpacing, "px"),
  toggle: {
    // background: undefined
    color: '#333',
    knob: {
      extend: "\n        background-color: ".concat(colorDefault, ";\n      ")
    },
    radius: '0px',
    size: "".concat(baseSpacing * 2, "px") // extend: undefined,

  }
};
var dataTable = {};
var table = {
  header: {
    background: colorDefault,
    color: colors.white,
    extend: "\n      font-weight: 600;\n    "
  },
  extend: "\n    & > tbody > tr:nth-child(odd)\n    {\n      background: ".concat(colors.lightGray, ";\n    }\n  ")
};
var layer = {
  border: {
    radius: '0px'
  },
  zIndex: 199,
  container: {
    zIndex: 199
  }
};
var select = {
  icons: {
    color: colorPrimary
  },
  options: {
    box: {
      extend: "\n        &:hover {\n          background-color: ".concat(colorPrimary, ";\n        }\n      ")
    }
  }
};
var accordion = {
  // heading: { level: "3" },
  icons: {
    collapse: _SubtractCircle.SubtractCircle,
    expand: _AddCircle.AddCircle,
    color: colorPrimary
  },
  border: false
};
var calendar = {};
var Theme = {
  fontFamily: '"Avenir", sans-serif;',
  global: global,
  colors: colors,
  colorDefault: colorDefault,
  colorPrimary: colorPrimary,
  colorSecondary: colorSecondary,
  text: text,
  button: button,
  heading: heading,
  drop: drop,
  suggestion: suggestion,
  box: box,
  anchor: anchor,
  checkBox: checkBox,
  table: table,
  dataTable: dataTable,
  layer: layer,
  select: select,
  accordion: accordion,
  calendar: calendar
};
var _default = Theme;
exports["default"] = _default;